import { Container, Content } from './styles';

interface CommentProps {
  id: number;
  autor: {
    id: number;
    name: string;
    sobrenome: string;
    foto: string;
  };
  comentario: string;
  tempo_passado: string;
}

interface CardProps {
  comment: CommentProps;
}

export const Card: React.FC<CardProps> = ({ comment }: CardProps) => {
  return (
    <Container>
      <Content>
        <span>
          <img
            src={
              comment.autor.foto
                ? comment.autor.foto
                : 'https://www.pinclipart.com/picdir/middle/157-1578186_user-profile-default-image-png-clipart.png'
            }
            alt={`Foto de ${comment.autor.name} ${comment.autor.sobrenome}`}
          />
        </span>

        <div>
          <span>
            <h1>{`${comment.autor.name} ${comment.autor.sobrenome}`}</h1>
            <p>{comment.comentario}</p>
          </span>
        </div>
      </Content>
    </Container>
  );
};
